fragment SimplifiedIndicator on Indicator {
  mostRecentValue
  aggregatedValue
  variation
}
